import Achievement from 'models/achievement/Achievement';

/**
 * Class representing a standalone achievement.
 * @extends Achievement
 */
export default class StandaloneAchievement extends Achievement {}
